<template>
	<div>
		<v-row no-gutters style="margin-top: 150px;">
			<v-col cols="12" style="z-index: 1;">
				<div bgColor="primary">
					<div class="text-md-h4 text-h5 font-weight-bold" align="center">
						Start Earning in 5 Seconds
					</div>

					<div class="text-body-1 font-weight-thin  mt-2" align="center">
						Sign up and pick from a variety of tasks to complete to start earning
						coins!
					</div>
				</div>
			</v-col>
		</v-row>

		<v-row no-gutters>
			<v-col col="12">
				<div class="rounded-xl d-flex flex-sm-row align-sm-center py-md-16 pb-sm-16 start-earning__background start-earning__grid-background"
					:elevation="24" :class="{ 'start-earning__element--hide': isUserLoggedIn }">
					<v-row no-gutters class="d-flex flex-row justify-space-around w-100 flex-wrap start-earning__stats px-10">
						<v-col cols="12" sm="6" md="3" class="pa-2 stats-tile" :data-target-count="9536">
							<StatsTile class="py-3 py-sm-6">
								<template v-slot:icon><person-icon></person-icon></template>
								<template v-slot:title>
									<span class="counter text-h4 text-lg-h3 font-weight-bold ">{{ registeredUsersCount }}</span>
								</template>
								<template v-slot:subtitle>
									<span class="text-body-2 text-md-body-1 font-weight-regular">Registered Users</span>
								</template>
							</StatsTile>
						</v-col>

						<v-col cols="12" sm="6" md="3" class="pa-2 stats-tile" :data-target-count="1567">
							<StatsTile class="py-3 py-sm-6">
								<template v-slot:icon><notes-icon></notes-icon></template>
								<template v-slot:title>
									<span class="counter text-h4 text-lg-h3 font-weight-bold">{{ taskCompleted }}</span>
								</template>
								<template v-slot:subtitle>
									<span class="text-body-2 text-md-body-1 font-weight-regular">Task Completed</span>
								</template>
							</StatsTile>
						</v-col>

						<v-col cols="12" sm="6" md="3" class="pa-2 stats-tile" :data-target-count="2567">
							<StatsTile class="py-3 py-sm-6">
								<template v-slot:icon><coin-stack-icon></coin-stack-icon></template>
								<template v-slot:title>
									<span class="counter text-h4 text-lg-h3 font-weight-bold ">${{ totalEarning }}</span>
								</template>
								<template v-slot:subtitle>
									<span class="text-body-2 text-md-body-1 font-weight-regular">Total Earning</span>
								</template>
							</StatsTile>
						</v-col>

						<v-col cols="12" sm="6" md="3" class="pa-2 stats-tile" :data-target-count="2045">
							<StatsTile class="py-3 py-sm-6">
								<template v-slot:icon><withdraw-money-icon></withdraw-money-icon></template>
								<template v-slot:title>
									<span class="counter text-h4 text-lg-h3 font-weight-bold ">${{ totalWithdrawal }}</span>
								</template>
								<template v-slot:subtitle>
									<span class="text-body-2 text-md-body-1 font-weight-regular">Total withdrawal</span>
								</template>
							</StatsTile>
						</v-col>
					</v-row>
					<v-row no-gutters v-if="!isUserLoggedIn">
						<v-col cols="12" sm="6" class="d-flex flex-column justify-center align-center px-4 mt-8">
							<img src="../../icons/SignupMoney.svg" alt=""
								style="height: 306px; max-width: 345px; width: 100%" />
						</v-col>

						<v-col cols="12" sm="6" class="d-flex flex-column justify-center align-start px-4">
							<div class="text-md-h4 text-h5 font-weight-bold mt-8 mt-lg-0">
								Sign up now & start earning money
							</div>

							<div class="text-body-1 font-weight-thin mt-3 mb-6">
								You are one click away from earning real cash
							</div>

							<div class="d-flex flex-row flex-wrap pb-4">
								<div id="g_id_onload" :data-client_id="AppConfigs.googleAppId" data-context="signin"
									data-ux_mode="popup" data-callback="handleCredentialResponse" data-auto_prompt="false">
								</div>

								<div class="g_id_signin" data-type="icon" data-shape="circle" data-theme="outline"
									data-text="signup_with" data-size="large" style="color-scheme: light;">
								</div>

								<v-btn icon color="#3b5998" size="small" class="pa-2 ml-2" @click="fbLogin">
									<facebook-white></facebook-white>
								</v-btn>
							</div>
						</v-col>
					</v-row>
				</div>
			</v-col>
		</v-row>
	</div>
</template>



<script>

/* global google */
/* global FB */

import { ref } from "vue";
import { useAuthStore } from "@/store/AuthStore";
import { useSnackbar } from '@/composables/useSnackbar';

import NotesIcon from "@/icons/Notes.vue";
import { AppConfigs } from "@/app.configs";
import PersonIcon from "@/icons/Person.vue";
import CoinStackIcon from "@/icons/CoinStack.vue";
import FacebookWhite from "@/icons/FacebookWhite.vue";
import WithdrawMoneyIcon from "@/icons/WithdrawMoney.vue";
import StatsTile from "@/components/Tiles/Stats-Tile.vue";

export default {
	name: "StartEarningComponent",
	components: {
		StatsTile,
		PersonIcon,
		NotesIcon,
		FacebookWhite,
		CoinStackIcon,
		WithdrawMoneyIcon,
	},
	setup() {
		const { showSnackbar } = useSnackbar();
		const authStore = useAuthStore();

		const handleCredentialResponse = (response) => {
			authStore.googleLoginResponse = response;
		}

		const fbLogin = () => {

			FB.login(
				(response) => {
					if (response.authResponse) {
						const accessToken = response.authResponse.accessToken;

						FB.api(
							"/me/permissions",
							{ access_token: accessToken },
							(permsResponse) => {
								const hasEmailPermission = permsResponse.data.some(
									(perm) =>
										perm.permission === "email" && perm.status === "granted"
								);

								if (hasEmailPermission) {
									authStore.facebookLoginResponse = response;
								} else {
									// Email permission not granted
									showSnackbar({
										message: "Email permission not granted",
										color: "error",
									});
								}
							}
						);
					} else {
						// user cancelled login
						showSnackbar({
							message: "Login Failed",
							color: "error",
						});
					}
				},
				{
					scope: "email",
				}
			);
		};

		return {
			fbLogin,
			authStore,
			AppConfigs,
			handleCredentialResponse,
		}
	},
	computed: {
		isUserLoggedIn() {
			return this.authStore.isUserLoggedIn();
		}
	},
	data() {
		return {
			registeredUsersCount: ref(0),
			registerUserTarget: ref(2500000),
			taskCompleted: ref(0),
			taskCompletedTarget: ref(700000000),
			totalEarning: ref(0),
			totalEarningTarget: ref(7000000),
			totalWithdrawal: ref(0),
			totalWithdrawalTarget: ref(5000000),
			observer: null,
			hasStartedAnimation: false,
		};
	},
	mounted() {
		this.setupIntersectionObserver();
		window.handleCredentialResponse = this.handleCredentialResponse;
	},
	methods: {
		setupIntersectionObserver() {
			const options = {
				threshold: 0.5,
			};
			this.observer = new IntersectionObserver(
				this.handleIntersection,
				options
			);
			// Add the observer to each StatsTile
			const statsTiles = document.querySelectorAll(".stats-tile");
			statsTiles.forEach((tile) => this.observer.observe(tile));
		},
		handleIntersection(entries) {
			entries.forEach((entry) => {
				if (entry.isIntersecting && !this.hasStartedAnimation) {
					// Start counting animation
					this.startCountAnimation(entry.target);
					// Disconnect the observer to stop further interactions
					this.observer.disconnect();
				}
			});
		},

		updateCounter(counterElement, currentCount, targetCount) {
			const animationDuration = 2000; // Set the duration in milliseconds
			const step = Math.ceil(
				(targetCount - currentCount) / (animationDuration / 20)
			);

			// Update the counter at regular intervals
			const animationInterval = setInterval(() => {
				// Update the current count
				if (currentCount < targetCount) {
					currentCount += step;
				} else {
					currentCount = targetCount;
				}

				// Display numbers with M, K, and +
				let displayCount;
				if (currentCount >= 100000000) {
					displayCount = Math.round(currentCount / 1000000) + "M"
				} else if (currentCount <= 99999999) {
					displayCount = Math.round(currentCount / 10000) + "K";
				} else {
					displayCount = currentCount.toString();
				}

				// Update the counter element
				counterElement.textContent = displayCount;

				// Check if the counter has reached the target
				if (currentCount === targetCount) {
					clearInterval(animationInterval);
					// Optionally, you can add a "+" suffix for numbers greater than the target
					if (currentCount > targetCount) {
						counterElement.textContent += "+";
					}
				}
			}, 20);
		},

		startCountAnimation() {
			const registeredUsersElement = document.querySelector(
				'.stats-tile[data-target-count="9536"] .counter'
			);
			const taskCompletedElement = document.querySelector(
				'.stats-tile[data-target-count="1567"] .counter'
			);
			const totalEarningElement = document.querySelector(
				'.stats-tile[data-target-count="2567"] .counter'
			);
			const totalWithdrawalElement = document.querySelector(
				'.stats-tile[data-target-count="2045"] .counter'
			);

			this.updateCounter(
				registeredUsersElement,
				this.registeredUsersCount,
				this.registerUserTarget
			);
			this.updateCounter(
				taskCompletedElement,
				this.taskCompleted,
				this.taskCompletedTarget
			);
			this.updateCounter(
				totalEarningElement,
				this.totalEarning,
				this.totalEarningTarget
			);
			this.updateCounter(
				totalWithdrawalElement,
				this.totalWithdrawal,
				this.totalWithdrawalTarget
			);

			this.hasStartedAnimation = true;
		},
	},
};
</script>
